import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/philippine-travel-hub/components/PhilippineHubInteractive.tsx");
